import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { trigger, transition, animate, style } from '@angular/animations';
import { AnalyticsService } from '../../core/services/analytics.service';
import { OrderService } from '../../core/services/data/order.service';

const DEFAULT_COVER_IMAGE = '../../../../../assets/img/defaults/default_book_image_400w_simple.jpg';

const popupAnimation = [
	trigger('dialog', [
		transition('void => *', [
			style({ transform: 'scale3d(.3, .3, .3)' }),
			animate(100),
		]),
		transition('* => void', [
			animate(100, style({ transform: 'scale3d(.0, .0, .0)' })),
		]),
	]),
];

@Component({
	selector: 'app-upsell-modal',
	templateUrl: './upsell-modal.component.html',
	styleUrls: [
		'./upsell-modal.component.scss',
	],
	encapsulation: ViewEncapsulation.None,
	animations: popupAnimation,
})
export class UpsellModalComponent implements OnInit {
	@Input() visible;

	@Input() applyingDiscount;

	@Input() paymentAmount;

	@Input()
	set featureImage(featureImage) {
		if (featureImage) {
			this._featureImage = featureImage;
		} else {
			this._featureImage = DEFAULT_COVER_IMAGE;
		}
	}

	@Input()
	set upsell(upsell) {
		if (upsell) {
			this._upsell = upsell;
			if (this._upsell && this._upsell.to) {
				this.toSiteAdvert = this._upsell.to.item;
				// Trigger GTM events
				this.as.trackUpsellImpressionAndPromotionViews(this._upsell);
			}
		}
	}

	@Output() closeUpsell = new EventEmitter();

	@Output() acceptUpsell = new EventEmitter();

	public _upsell;

	public toSiteAdvert;

	public _featureImage;

	public order$;

	public cart;

	public totalPaymentAmount;

	get getHeaderPaymentAmount() {
		let total: number = this.paymentAmount;
		if (!this.applyingDiscount) total = this.toSiteAdvert.price;

		const amount = total.toFixed(2);
		return amount.replace('.00', '');
	}

	get getTotalPaymentAmount() {
		const currentOrderTotal = this.os.calculateOrderTotal();
		let total: number = (currentOrderTotal + this.paymentAmount);
		if (!this.applyingDiscount) total = (currentOrderTotal + this.toSiteAdvert.price);

		const amount = total.toFixed(2);
		return amount.replace('.00', '');
	}

	constructor(
		private as: AnalyticsService,
		private os: OrderService,
	) { }

	ngOnInit() {
		this.order$ = this.os.orderStore$.subscribe((data: any) => {
			this.cart = data;
		});
	}

	onAcceptUpsell() {
		this.acceptUpsell.emit();

		const { _siteAdvert, _site, paymentAmount } = this.cart.items[0].item;
		const ecommerceItem = this.as.generateAnalyticsEcommerceObject(
			_siteAdvert.seoSlug,
			_siteAdvert.name,
			_site.name,
			_siteAdvert.parentGenre,
			paymentAmount,
			1,
			_site.name,
		);
		this.as.trackAddToCart2(paymentAmount, [ecommerceItem]);
	}

	onClose() {
		setTimeout(() => this.closeUpsell.emit(), 110);
	}
}
